import { createStyles, Theme } from '@material-ui/core';

const courseCardStyles = (theme: Theme) =>
    createStyles({
        coursePlanChangeRequestRow: {
            position: 'relative',
            cursor: 'pointer',
            '& .coursePlanChangeRequestCol': {
                backgroundColor: '#FFFFFF',
                borderRadius: '8px',
                width: '100%',
                padding: '16px 20px',
                marginBottom: '12px',
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                '&:hover': {
                    boxShadow: '0px 4px 10px 0px #babfc5',
                },
                '& h2': {
                    fontSize: '24px',
                    fontWeight: 600,
                    lineHeight: '32px',
                    color: '#333333',
                    margin: '0',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    position: 'relative',
                    '&:hover + .tooltip': {
                        opacity: 1,
                        transition: 'all 0.3s',
                    }
                },
                '& .tooltip': {
                    position: 'absolute',
                    top: '53px',
                    left: '20px',
                    width: '100%',
                    maxWidth: '500px',
                    padding: '5px 10px',
                    backgroundColor: '#7b7b7b',
                    borderRadius: '4px',
                    color: '#fff',
                    fontSize: '14px',
                    fontWeight: 400,
                    opacity: 0,
                    transition: 'all 0.3s',
                    '&::before': {
                        content: "''",
                        width: 0,
                        height: 0, 
                        borderLeft: '5px solid transparent',
                        borderRight: '5px solid transparent',
                        borderBottom: '5px solid #7b7b7b',
                        position: 'absolute',
                        top: '-5px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                    }
                },
                '& .courseNameRow': {
                    display: 'flex',
                    alignItems: 'center',
                    '& .courseNameCol': {
                        width: '50%',
                        fontSize: '16px',
                        fontWeight: 400,
                        color: '#666666',
                        display: 'inline-flex',
                        alignItems: 'center',
                        '& .courseIcon': {
                            marginRight: '10px',
                        },
                        '& span': {
                            marginTop: '3px',
                        }
                    },
                    '& .courseDate': {
                        width: '50%',
                        textAlign: 'right',
                        fontSize: '16px',
                        fontWeight: 400,
                        color: '#333333',
                        '& span': {
                            color: '#999999',
                        }
                    },
                },
                '& .requestedList': {
                    borderTop: 'solid 1px #DDDDDD',
                    padding: '16px 0 0',
                    margin: '16px 0 0',
                    display: 'flex',
                    alignItems: 'center',
                    listStyle: 'none',
                    '& li': {
                        fontSize: '16px',
                        fontWeight: 400,
                        lineHeight: '20px',
                        color: '#666666',
                        '&::after': {
                            content: "''",
                            width: '4px',
                            height: '4px',
                            borderRadius: '50%',
                            backgroundColor: '#D9D9D9',
                            display: 'inline-block',
                            verticalAlign: 'middle',
                            margin: '0 10px',
                        },
                        '&:last-child::after': {
                            display: 'none',
                        },
                        '& span': {
                            color: '#333333',
                        }
                    }
                },
                '& .coursePlanName': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '12px',
                }
            }
        }
        ,
        basePlanText: {
            backgroundColor: '#FBFBFB',
            padding: '7.5px 10px',
            fontSize: '14px',
            fontWeight: 600,
            color: '#379D0B',
            lineHeight: '142%',
            margin: '0 0 0 15px',
            whiteSpace: 'nowrap',
            '& span': {
                fontSize: '12px',
                color: '#1D7DEA',
                paddingLeft: '11px',
                cursor: 'pointer',
            }
        }
    })

export default courseCardStyles;